import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e72f1966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field search" }
const _hoisted_2 = { class: "control has-icons-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1))
const _hoisted_4 = { class: "list" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Você não está muito produtivo hoje :( ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nenuhuma task com essa descrição encontrada :( ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_8 = { class: "modal-card" }
const _hoisted_9 = { class: "modal-card-head" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Editando uma tarefa!", -1))
const _hoisted_11 = { class: "modal-card-body" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "label"
}, " Descrição ", -1))
const _hoisted_14 = { class: "modal-card-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_Task = _resolveComponent("Task")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, { onOnSaveTask: _ctx.addTask }, null, 8, ["onOnSaveTask"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
          class: "input",
          type: "text",
          placeholder: "Busque uma tarefa..."
        }, null, 512), [
          [_vModelText, _ctx.filter]
        ]),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, index) => {
        return (_openBlock(), _createBlock(_component_Task, {
          key: index,
          task: task,
          onOnTriggeredTask: ($event: any) => (_ctx.taskSelect(task))
        }, null, 8, ["task", "onOnTriggeredTask"]))
      }), 128)),
      (_ctx.listIsEmpty.tasksIsEmpty)
        ? (_openBlock(), _createBlock(_component_Box, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.listIsEmpty.filterIsEmpty)
        ? (_openBlock(), _createBlock(_component_Box, { key: 1 }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedTask)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal", { 'is-active': _ctx.selectedTask }])
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("header", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modalClose && _ctx.modalClose(...args))),
                class: "delete",
                "aria-label": "close"
              })
            ]),
            _createElementVNode("section", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTask.description) = $event)),
                  id: "description"
                }, null, 512), [
                  [_vModelText, _ctx.selectedTask.description]
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_14, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.editTask && _ctx.editTask(...args))),
                class: "button is-success"
              }, "Salvar"),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.modalClose && _ctx.modalClose(...args))),
                class: "button"
              }, "Cancelar")
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}